<template>
  <div class="table_wrap">
    <div class="c_table_wrap table_search_wrap">
      공지사항 필터
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardFilterNoticeLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>